import React from "react";
import Navbar from "../Layout/Navbar";
import {compose} from "redux";
import {firestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import {Col, Row, Spin, Button, Drawer, Form, TimePicker, List, Tabs, Layout, Menu, Breadcrumb, Avatar} from "antd";
import moment from "moment";
import {updateWorkingHours} from "../../Store/Actions/shop";
import {
    ShoppingCartOutlined,
    QuestionCircleOutlined,
    ExclamationCircleOutlined,
    TeamOutlined,
} from '@ant-design/icons';
import Items from "../Items/index"
import "./admin.css"
import Faq from "./faq";
import Questions from "./Questions";
import JobRequests from "./JobRequests";
const { Sider } = Layout;


class Admin extends React.Component {

    state = {
        collapsed: true,
        selected: "requests"
    };

    onCollapse = collapsed => {
        this.setState({ collapsed });
    };

    onSelect = selected => {
        this.setState({
            selected: selected.key
        });
    }


    render() {
        const { selected } = this.state;

        const views = {
            "requests": <JobRequests />,
            "items": <Items />,
            "questions": <Questions />,
            "faqs": <Faq />
        }


        return(
            <div>
                <div>
                    <Layout style={{ minHeight: 'calc(100vh - 48px)' }}>
                        <Sider collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
                            <div>
                                <Menu selectedKeys={[selected]} onSelect={this.onSelect} defaultSelectedKeys={["requests"]} mode="inline">
                                    <Menu.Item key="requests" icon={<TeamOutlined />}>
                                        Requests
                                    </Menu.Item>
                                    <Menu.Item key="items" icon={<ShoppingCartOutlined />}>
                                        Items
                                    </Menu.Item>
                                    <Menu.Item key="faqs" icon={<ExclamationCircleOutlined />}>
                                        FAQ
                                    </Menu.Item>
                                    <Menu.Item key="questions" icon={<QuestionCircleOutlined />}>
                                        Questions
                                    </Menu.Item>
                                </Menu>
                            </div>

                        </Sider>
                        <Layout className="site-layout uk-padding">
                            <div className={"uk-background-default uk-border-rounded uk-padding"}>
                                { views[selected] }
                            </div>
                        </Layout>
                    </Layout>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {


    return {
        auth: state.firebase.auth,
        shop: state.firestore.ordered.shops ? state.firestore.ordered.shops[0] : null
    }
}

const enhance = compose(
    firestoreConnect((props) => [
        { collection: "shops", doc: props.match.params.id }
    ]),
    connect(mapStateToProps)
);
export default enhance(Admin);



// WEBPACK FOOTER //
// ./src/Components/Admin/index.js